const NotFound = () => {
  return <div>THis is not found</div>;
};

export default NotFound;
